import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    errors: {
      forbiddenBic:
        'This BIC is not accepted at the moment\nIf the IBAN belongs to Crédit Agricole, enter the BIC AGRIFRPP',
      ibanNotMatchingCountry:
        'This IBAN does not correspond to the country indicated above.',
      swiftBicNotMatchingCountry:
        'This BIC does not correspond to the country indicated above.',
    },
    labels: {
      country: 'Country',
      name: 'First name and surname or company name',
      swiftBic: 'BIC',
    },
    placeholders: {
      name: 'For example: John Doe, Law Society, ...',
    },
  },
  fr: {
    errors: {
      forbiddenBic:
        'Ce BIC n’est pas accepté pour le moment.\nSi l’IBAN appartient au Crédit Agricole, saisissez le BIC AGRIFRPP',
      ibanNotMatchingCountry:
        'L’IBAN ne correspond pas au pays indiqué ci-dessus.',
      swiftBicNotMatchingCountry:
        'Le BIC ne correspond pas au pays indiqué ci-dessus.',
    },
    labels: {
      country: 'Pays',
      name: 'Prénom et nom ou raison sociale',
      swiftBic: 'BIC',
    },
    placeholders: {
      name: 'Par ex : John Doe, Société des Avocats, ...',
    },
  },
} as const);

export default locales;
